export var StakeModifier;
(function (StakeModifier) {
    StakeModifier["plus"] = "plus";
    StakeModifier["minus"] = "minus";
})(StakeModifier || (StakeModifier = {}));
export var PriceStatusClass;
(function (PriceStatusClass) {
    PriceStatusClass["periodOver"] = "over";
    PriceStatusClass["periodResulting"] = "resulting";
    PriceStatusClass["periodCurrent"] = "current";
    PriceStatusClass["periodPre"] = "not-started";
})(PriceStatusClass || (PriceStatusClass = {}));
//# sourceMappingURL=Modifiers.js.map